import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSeconds: 5000,
  postJobId: "",
  openConfirmationModal: false,
};

const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    toastSeconds: (state, { payload }) => {
      state.isSeconds = payload;
    },
    setOpenConfirmationModal: (state) => {
      state.openConfirmationModal = true;
    },
    setCloseConfirmationModal: (state) => {
      state.openConfirmationModal = false;
    },
    setPostJobId: (state, { payload }) => {
      state.postJobId = payload;
    },
  },
});

export default generalSlice.reducer;

export const {
  toastSeconds,
  setOpenConfirmationModal,
  setCloseConfirmationModal,
  setPostJobId,
} = generalSlice.actions;
